<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="420"
    transition="dialog-bottom-transition"
  >
    <v-card class="maintenance-card">
      <!-- Header CLARO (no mata el logo) -->
      <div class="header-light">
        <img
          class="brand-logo"
          src="https://apitr.xyz/dominio/trnet/logo.svg"
          alt="Track & Races Logo"
        />
      </div>

      <v-card-text class="text-center pt-5 pb-3">
        <h3 class="text-subtitle-1 font-weight-bold dark-blue--text mb-2">
          CANALES DE COMUNICACIÓN
        </h3>

        <p class="grey--text text--darken-1 text-body-2 mb-3">
          Atención por nuestros canales oficiales:
        </p>

        <v-list dense class="channels-list">
          <!-- Chat interno (principal) -->
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="#0F1F38" small>mdi-chat</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-left">
              <v-list-item-title class="dark-blue--text font-weight-bold">
                Chat interno del sitio
              </v-list-item-title>
              <v-list-item-subtitle class="text-body-2">
                (Canal principal)
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-1"></v-divider>

          <!-- Telegram (logo oficial SVG) -->
          <v-list-item>
            <v-list-item-icon>
              <span class="tg-icon" aria-label="Telegram">
                <!-- Telegram official-style mark (plane) -->
                <svg viewBox="0 0 240 240" width="18" height="18" role="img" aria-hidden="true">
                  <circle cx="120" cy="120" r="120" fill="#229ED9"/>
                  <path
                    d="M179.9 73.1L155.8 187.6c-1.8 8.1-6.6 10.1-13.3 6.3l-36.8-27.1-17.7 17.0c-2.0 2.0-3.6 3.6-7.4 3.6l2.6-37.3 67.9-61.3c2.9-2.6-0.6-4.0-4.5-1.4L63.8 128.5l-35.7-11.1c-7.8-2.4-8.0-7.8 1.6-11.6l139.6-53.8c6.5-2.4 12.1 1.6 10.6 11.1z"
                    fill="#ffffff"
                  />
                </svg>
              </span>
            </v-list-item-icon>

            <v-list-item-content class="text-left">
              <v-list-item-title class="dark-blue--text font-weight-bold">
                Telegram
              </v-list-item-title>
              <v-list-item-subtitle class="text-body-2">
                +51 933 292 975
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-1"></v-divider>

          <!-- WhatsApp -->
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="#25D366" small>mdi-whatsapp</v-icon>
            </v-list-item-icon>

            <v-list-item-content class="text-left">
              <v-list-item-title class="dark-blue--text font-weight-bold">
                WhatsApp
              </v-list-item-title>
              <v-list-item-subtitle class="text-body-2">
                +51 933 292 975
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions class="justify-center pb-4">
        <v-btn
          color="#0F1F38"
          dark
          large
          elevation="1"
          class="px-7"
          @click.stop="closeDialog"
        >
          CERRAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MaintenanceModal",
  props: {
    // v-model del padre (Vue 2)
    value: { type: Boolean, default: false },
  },
  computed: {
    dialog: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.maintenance-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.dark-blue--text {
  color: #0F1F38 !important;
}

/* Header claro para que el logo negro se vea */
.header-light {
  background: #ffffff; /* puedes cambiar a #F6F8FB si quieres un tono */
  padding: 14px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eef1f5;
}

.brand-logo {
  height: 40px;
  max-width: 220px;
  object-fit: contain;
}

.channels-list {
  border-radius: 10px;
  background: #fafafa;
  padding: 4px 6px;
}

.tg-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>